import React, { useState, useEffect } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";

import Home from "./components/Home";
import Footer from "./components/Footer";
import Preloader from "./components/util/Preloader";

import "./App.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#e1eddb",
        dark: "#e1eddb94",
      },
      secondary: {
        main: "#fffaee",
        dark: "fffaee94"
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Preloader load={load} />
        <div className="app">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </ThemeProvider >
  );
}

export default App;
